import validator from 'validator';
declare var jQuery:any;

interface fieldData {
    name:string,
    type:string,
    required:boolean,
    input_type:string,
    value:any,
}

interface fieldArr {
    [key:string]: fieldData;
}

interface formValueData {
    action:string,
    fields: fieldArr
}

interface localize {
    admin_ajax:string,
    admin_post:string,
    nonce_validate_registration_files:string,
    allowed_mime_types:{[key:string]:string},
    max_allowed_file_size:number, // in bytes
    max_allowed_total_file_size:number, // in bytes
    organization_email_required:boolean,
    min_password_strength?:number, // 0=any, 1=bad+, 2=fair+, 3=good+, 4=strong (Platform Settings)
    phone_invalid_error?:string,
}

interface FormSection {
    'element': any,
    'section_id':string,
    'section_index':number,
    'section_group_type_index': number,
    'enabled':boolean,
    'validated':boolean,
}

declare var register_localize:localize;

class PlatformRegister {
    public static register_form_id:string='form.register-unique';
    public sections:Array<FormSection>=[];

    constructor() {
    }

    init = () => {
        if (jQuery(`${PlatformRegister.register_form_id}`).length == 0) {
            return;
        }
        this.init_sections();
        this.initPasswordWeakFields();

        jQuery('#account_type,#account_type_org').on('change', (e: any) => {
            var accountType = jQuery(e.target).val();
            this.handle_account_type_change(accountType);
        })
        this.handle_account_type_change(jQuery('#account_type').val() ?? '');

        var acc = document.querySelectorAll('.multi_registration_forms .accordion');

        acc.forEach(function(accordion) {
            accordion.addEventListener("click", function() {
              this.classList.toggle("active");
              var panel = this.nextElementSibling;
              if (panel instanceof HTMLElement) {
                panel.style.display = panel.style.display === "block" ? "none" : "block";
              }
              // Close other sections
              acc.forEach(function(otherAccordion) {
                if (otherAccordion !== accordion) {
                  var otherPanel = otherAccordion.nextElementSibling;
                  if (otherPanel instanceof HTMLElement) {
                    otherPanel.style.display = "none";
                  }
                }
              });
            });
        });
    }

    handle_progress_indicator_step_click(eventTarget: any) {
        const target_section_group_type_index = jQuery(eventTarget).parent().data('nav');
        var indicator_container = jQuery(eventTarget).closest('.vm-custom-fields-pagination');
        
        // allow clicking on previous steps only
        if ( target_section_group_type_index < parseInt(indicator_container.find('.forminator-current').data('nav'))) {
            if (indicator_container.length) {
                let section_prefix = '';
                if (indicator_container.attr('id') == 'custom-fields-pagination--organization') {
                    section_prefix = 'organization_section';
                } else if (indicator_container.attr('id') == 'custom-fields-pagination--general') {
                    section_prefix = 'user_section';
                } else {
                    console.error('Invalid steps-indicator container', indicator_container.attr('id') , this.sections, target_section_group_type_index, section_prefix);
                    return;
                }
                
                const target_section = this.sections.filter(section => {
                    return section.section_group_type_index == target_section_group_type_index && section.section_id.startsWith(section_prefix);
                })
                if (target_section.length && indicator_container.find('.forminator-current').length) {
                    this.activate_section(target_section[0]);
                }
            } else {
                console.error('Indicator container was not found!');
            }
        }
    }

    update_progress_indicator = (section: FormSection) => {
        let container;
        let total_steps;
        if (section.section_id.startsWith('organization_section')) {
            total_steps = jQuery('section.organization-section').length;
            jQuery('#custom-fields-pagination--general').hide();
            container = jQuery('#custom-fields-pagination--organization');
            container.show();
        } else {
            total_steps = jQuery('section.user-section').length;
            jQuery('#custom-fields-pagination--organization').hide();
            container = jQuery('#custom-fields-pagination--general');
            container.show();
        }
        let current_step = section.section_group_type_index;
        
        if (container.length) {
            if (container.find('.forminator-pagination-steps').length) {
                container.find('.forminator-pagination-steps .forminator-step').removeClass('forminator-current');
                container.find('.forminator-pagination-steps .forminator-step-' + current_step).addClass('forminator-current');
            } else if (container.find('.forminator-pagination-progress').length) {
                container.find('.forminator-pagination-progress .forminator-progress-label').html((100 * (current_step + 1) / total_steps).toFixed(0) + '%');
                container.find('.forminator-pagination-progress .forminator-progress-bar span').css('width', (100 * (current_step + 1) / total_steps).toFixed(0) + '%');
            }
        }
    }

    /** Platform Settings "Minimum password strength" (0–4). Fallback: WC params, then 1. */
    getMinPasswordStrength = (): number => {
        if (typeof register_localize !== 'undefined' && typeof register_localize.min_password_strength === 'number') {
            return register_localize.min_password_strength;
        }
        const params = (window as any).wc_password_strength_meter_params;
        if (params && params.min_password_strength !== undefined) {
            return parseInt(String(params.min_password_strength), 10);
        }
        return 1;
    };

    /** True when strength meter shows below required minimum (blocks submit). */
    isPasswordBelowMin = (): boolean => {
        const $meter = jQuery('.woocommerce-password-strength');
        if (!$meter.length) return false;
        let strength = -1;
        if ($meter.hasClass('short')) strength = 0;
        else if ($meter.hasClass('bad')) strength = 1;
        else if ($meter.hasClass('good')) strength = 3;
        else if ($meter.hasClass('strong')) strength = 4;
        const min = this.getMinPasswordStrength();
        return strength >= 0 && strength < min;
    };

    /**
     * Add/remove 'has-weak-password' on form when password is below Platform Settings minimum.
     */
    initPasswordWeakFields = () => {
        const passwordFieldIds = '#reg_password';
        const self = this;
        const updateWeakPasswordClass = () => {
            const minStrength = self.getMinPasswordStrength();
            jQuery(passwordFieldIds).each(function () {
                const $field = jQuery(this);
                const $form = $field.closest('form');
                if (!$form.length) return;
                const $meter = $form.find('.woocommerce-password-strength');
                let strength = -1;
                if ($meter.length) {
                    if ($meter.hasClass('short')) strength = 0;
                    else if ($meter.hasClass('bad')) strength = 1;
                    else if ($meter.hasClass('good')) strength = 3;
                    else if ($meter.hasClass('strong')) strength = 4;
                }
                if (strength >= 0 && strength < minStrength) {
                    $form.addClass('has-weak-password');
                } else {
                    $form.removeClass('has-weak-password');
                }
            });
        };
        jQuery(document.body).on('keyup change', passwordFieldIds, () => setTimeout(updateWeakPasswordClass, 100));
        setTimeout(updateWeakPasswordClass, 500);
    };

    init_sections = () => {
        jQuery(`section[data-register-section]`).each( (index:number, section_el:any) => {
            if( section_el ) {
                section_el = jQuery(section_el)
                const sectionID = section_el.data('section');
                const sectionGroupTypeIndex = section_el.data('section-group-type-index');
                const sectionIndex = section_el.data('register-section');

                const section: FormSection = {
                    'element': section_el,
                    'section_id': sectionID,
                    'section_index': sectionIndex,
                    'section_group_type_index': sectionGroupTypeIndex,
                    'enabled': true,
                    'validated': false,
                }

                this.sections[sectionIndex] = section

                section.element.find(`button[data-vm-action='next'], input[data-vm-action='next']`).on('click', async (e: any) => {
                    jQuery(e.target).attr('disabled', 'disabled')
                    // clear rwmb-error class of file inputs. (The rwmb script doesn't removed rwmb-error class for the unrequired file fields).
                    section.element.find('input[type="file"]').removeClass("rwmb-error");
                    
                    // this.myFormHandler.show_loader();
                    // submit form to trigger default behaviour of rwmb form.
                    section.element.parent('form').submit()

                    let org_email_exist = false;

                    if (section.section_id === 'user_section_0') {
                        if (!section.validated) {
                            const validated = await this.validate(section);
        
                            if (!validated) {
                                jQuery(e.target).removeAttr('disabled')
                                this.myFormHandler.hide_loader();
                                // terminate the submission by return
                                return;
                            }
                            section.validated = true;

                            // Set a timeout to allow other validation logic to run first
                            setTimeout(() => {
                                if (this.isPasswordBelowMin()) {
                                    console.log('Password strength is too weak, not submitting.');
                                    jQuery('.woocommerce-password-strength').addClass('rwmb-error');
                                    return;
                                } else {
                                    jQuery('.woocommerce-password-strength').removeClass('rwmb-error');
                                }
                            }, 10);
                        }
                    } else {
                        const org_email_input = jQuery("#org_organization_email");
                        if (register_localize.organization_email_required && org_email_input.length > 0) {
                            if (org_email_input.val().trim() == '') {
                                jQuery("#org_organization_email-error.rwmb-error").remove();
                                org_email_input.addClass('rwmb-error');
                                org_email_input.after(`<p id="org_organization_email-error" class="rwmb-error">This field is required.</p>`) // hanlde localization?
                            }
                        }

                        const org_name_input = jQuery("#org_organization_name");
                        if (org_name_input.length > 0) {
                            if (org_name_input.val().trim() == '') {
                                jQuery("#org_organization_name-error.rwmb-error").remove();
                                org_name_input.addClass('rwmb-error');
                                org_name_input.after(`<p id="org_organization_name-error" class="rwmb-error">This field is required.</p>`) // hanlde localization?
                            }
                        }                        

                        if (org_email_input.length > 0) {
                            // fore email flag is true and waiting for email valition.
                            org_email_exist = true;
                            
                            // org email already exists check. (Utilize the "vm_email_exists" aj
                            // ax of user.)
                            var emailFormData:FormData = new FormData();
                            emailFormData.append( "action", "vm_email_exists" );
                            emailFormData.append( "str_email", org_email_input.val() );

                            const response = await fetch( register_localize.admin_ajax, {
                                method: 'POST',
                                credentials: 'same-origin',
                                body: emailFormData,
                            } );

                            const data = await response.json();
                            if ( data && data.hasOwnProperty('success') ) {
                                if ( data.success && !data.email_exists ) {
                                    org_email_exist = false;
                                }
                                if( data.success && !data.valid_email ) {
                                    // avoid duplicate error message
                                    if (!org_email_input.hasClass('rwmb-error')) {
                                        org_email_input.addClass('rwmb-error');
                                        org_email_input.after(`<p id="org_organization_email-error" class="rwmb-error">Invalid email</p>`) // hanlde localization?
                                    }
                                }
                            }
                            if (org_email_exist) {
                                org_email_input.addClass('rwmb-error');
                                org_email_input.after(`<p id="org_organization_email-error" class="rwmb-error">Organization Email already in use.</p>`) // hanlde localization?
                            }
                        }
                    }

                    // Set a timeout to allow other validation logic to run first
                    setTimeout(async () => {
                        if (!this.validatePhoneFieldsInSection(section)) {
                            jQuery(e.target).removeAttr('disabled');
                            this.myFormHandler.hide_loader();
                            section.validated = false;
                            return;
                        }

                        if (org_email_exist || section.element.find('.rwmb-error').filter(function() {
                            const styleAttr = jQuery(this).attr('style');
                            return styleAttr === undefined || styleAttr === '';
                        }).length > 0) {
                            jQuery(e.target).removeAttr('disabled')
                            this.myFormHandler.hide_loader();
                            // If there are errors (visible errors with an empty style attribute)
                            console.log('Form has errors, not submitting.');
                            section.validated = false;
                            return;
                        } else {
                            if (this.myFormHandler.hasFileInputs([section])) {
                                // this.myFormHandler.show_loader();
                                const validation = await this.myFormHandler.validateFiles([section]);
                                jQuery(e.target).removeAttr('disabled')
                                this.myFormHandler.hide_loader();
                                // remove rwmb top validation message if exist
                                jQuery("#rwmb-validation-message").remove();
                                if (!validation.success) {
                                    // show top error message
                                    if (validation.message.length > 0) {
                                        this.myFormHandler.show_error_message(validation.message, section);
                                    // @ts-ignore
                                    } else if (typeof rwmbValidation !== 'undefined') {
                                        // @ts-ignore
                                        this.myFormHandler.show_error_message(rwmbValidation.message, section);
                                    }
                                    section.validated = false;
                                    return;
                                }
                            }
                            jQuery(e.target).removeAttr('disabled')
                            this.myFormHandler.hide_loader();
                            section.validated = true;
                            this.move_next(section)
                        }
                    }, 200);

                    return true;
                });
        
                section.element.find(`button[data-vm-action='submit']`).on('click', async (e: any) => {
                    e.preventDefault();
                    jQuery(e.target).attr('disabled', 'disabled')
                    // clear rwmb-error class of file inputs. (The rwmb script doesn't removed rwmb-error class for the unrequired file fields).
                    section.element.find('input[type="file"]').removeClass("rwmb-error");

                    if (section.section_id === 'user_section_0') {
                        this.myFormHandler.show_loader();
    
                        const validated = await this.validate(section);

                        if (!validated) {
                            // submit the form to trigger default behaviour of rwmb form to show the error messages.
                            section.element.parent('form').submit();

                            jQuery(e.target).removeAttr('disabled')
                            this.myFormHandler.hide_loader();
                            return;
                        }

                            // Set a timeout to allow other validation logic to run first
                            setTimeout(() => {
                                if (this.isPasswordBelowMin()) {
                                    console.log('Password strength is too weak, not submitting.');
                                    jQuery('.woocommerce-password-strength').addClass('rwmb-error');
                                    return;
                                } else {
                                    jQuery('.woocommerce-password-strength').removeClass('rwmb-error');
                                }
                            }, 10);
                        
                        section.element.parent('form').submit();
                    } else {
                        section.element.parent('form').submit();
                    }
                    jQuery(e.target).removeAttr('disabled')
                    this.myFormHandler.hide_loader();
                    
                    return true;
                    
                });
        
                section.element.find(`button[data-vm-action='back']`).on('click', (e: any) => {
                    this.move_back(section);
                    jQuery( '#rwmb-validation-message' ).remove();
                });        
        
                section.element.parent('form.login_register_wrapper.rwmb-form').on('submit', (event: any) => {
                    this.myFormHandler.handleSubmit(event, this.sections);
                });
            }
        });

        jQuery('.vm-custom-fields-pagination .forminator-step').on('click', (e: any) => {
            this.handle_progress_indicator_step_click(e.target);
        })
    }

    get_next_section = (section: FormSection) => {
        for (let i=0; i < this.sections.length - section.section_index; i++) {
            const next_section = this.sections[section.section_index + 1 + i];
            if (next_section && next_section.enabled) {
                return next_section;
            }
        }
        
        return null;
    }

    get_prev_section = (section: FormSection) => {
        for (let i=0; i < section.section_index; i++) {
            const prev_section = this.sections[section.section_index - 1 - i];
            if (prev_section && prev_section.enabled) {
                return prev_section;
            }
        }
        return null;
    }

    get_first_user_section = () => {
        for (let i=0; i < this.sections.length; i++) {
            if (this.sections[i].section_id == 'user_section_0') {
                return this.sections[i]
            }
        }
        return null;
    }

    get_first_org_section = () => {
        for (let i=0; i < this.sections.length; i++) {
            if (this.sections[i].section_id.startsWith('organization_section')) {
                return this.sections[i]
            }
        }
        return null;
    }

    handle_account_type_change = (account_type: string) => {
        if (jQuery('#account_type').val() != account_type) {
            jQuery('#account_type').val(account_type);
        }
        if (jQuery('#account_type_org').val() != account_type) {
            jQuery('#account_type_org').val(account_type);
        }

        if (account_type == '' || account_type == 'individual') {
            jQuery('#account_type').parent().show();
        } else {
            jQuery('#account_type').parent().hide();
        }
        
        // enable/disable organization sections
        if (account_type === 'organization') {
            this.enable_org_sections()
        } else if (account_type === 'individual') {
            this.disable_org_sections()
        } else {
            this.disable_org_sections()
        }
        // Reset the main top error if exist
        jQuery(".registration-error").remove();
    }

    show_back_button = (section: FormSection) => {
        if (!section) return;
        section.element.find(`button[data-vm-action='back'], input[data-vm-action='back']`).show();
        section.element.find(`button.uk-width-1-1[data-vm-action='next'], input[data-vm-action='next']`).removeClass('uk-width-1-1').addClass('uk-width-1-3');
        section.element.find(`button.uk-width-1-1[data-vm-action='submit'], input[data-vm-action='submit']`).removeClass('uk-width-1-1').addClass('uk-width-1-3');

    }

    hide_back_button = (section: FormSection) => {
        section.element.find(`button[data-vm-action='back'], input[data-vm-action='back']`).hide();
        section.element.find(`button.uk-width-1-3[data-vm-action='next'], input[data-vm-action='next']`).removeClass('uk-width-1-3').addClass('uk-width-1-1');
        section.element.find(`button.uk-width-1-3[data-vm-action='submit'], input[data-vm-action='submit']`).removeClass('uk-width-1-3').addClass('uk-width-1-1');
    }

    set_active_step(index: number) {
        const steps = jQuery(".account-type-organization").find('.step');
        steps.each((i: number, step: any) => {
            step.classList.toggle('active', i === index);
        });
      }

    enable_org_sections = () => {
        this.sections.forEach(function(section, index) {
            if (section.section_id.startsWith('organization_section')) {
                section.enabled = true
            }
        });
        jQuery(".steps-wrapper.account-type-organization").show();
        this.set_active_step(0);
        
        const first_user_section = this.get_first_user_section()
        const first_org_section = this.get_first_org_section()
        this.activate_section(first_org_section)
        this.show_back_button(first_user_section)
    }

    disable_org_sections = () => {
        const first_user_section = this.get_first_user_section()
        this.sections.forEach(function(section, index) {
            if (section.section_id.startsWith('organization_section')) {
                section.enabled = false
            }
        });
        jQuery(".steps-wrapper.account-type-organization").hide();
        this.set_active_step(0);

        this.activate_section(first_user_section)
        this.hide_back_button(first_user_section)
    }

    activate_section = (section: FormSection) => {
        if (!section) return;
        section.validated = false;
        section.element.addClass('active--section')
        section.element.removeClass("hidden");
        this.update_progress_indicator(section);

        this.deactivate_other_sections(section);

        // Re-init address country/state Select2 after section becomes visible (account type switch).
        window.setTimeout(() => {
            jQuery(document.body).trigger('vm_address_fixed_sections_visible');
        }, 150);
    }

    deactivate_other_sections = (except_section: FormSection) => {
        if (!except_section) return;
        const self = this;
        const prev_section = this.get_prev_section(except_section)
        
        this.sections.forEach(function(section, index) {
            // first section is always active.
            if (!except_section || section.section_id !== except_section.section_id) {
                self.reset_section_errors(section)
                section.element.removeClass('active--section')
                section.element.addClass("hidden");
            }
        });
    }

    move_next = (current_section: FormSection) => {
        const next_session = this.get_next_section(current_section);
        if (next_session) {
            if (next_session.section_id.startsWith('organization_section')) {
                this.set_active_step(0);
            } else {
                this.set_active_step(1);
            }
            this.activate_section(next_session)
            this.deactivate_other_sections(next_session)
        } else {
            console.error("No section to move next.");
        }
    }

    move_back = (current_section: FormSection) => {
        const prev_session = this.get_prev_section(current_section);
        if (prev_session) {
            if (prev_session.section_id.startsWith('organization_section')) {
                this.set_active_step(0);
            } else {
                this.set_active_step(1);
            }
            this.activate_section(prev_session)
            this.deactivate_other_sections(prev_session)
        } else {
            console.error("No section to move back.");
        }
    }

    reset_section_errors = (section: FormSection) => {
        section.validated = false
        // metabox field errors
        section.element.parent().parent().find('#rwmb-validation-message').remove()
        section.element.find('p.rwmb-error').remove()
        section.element.find('.rwmb-error').removeClass('rwmb-error')

        section.element.parent().parent().find('#submit-error-message').remove()
        section.element.find('.rwmb-error').removeClass('rwmb-error')
        section.element.find('.form--error-field').empty()
    }

    myFormHandler = {
        get_all_field_data: function(sections: Array<FormSection>) {
            var data = new FormData();
            const enabled_sections = sections.filter(section => section.enabled);
            
            if (enabled_sections.length <= 0) return data;

            enabled_sections.forEach((section, index) => {
                const build_field_name = function(field_name: string) {
                    if (section.section_id.startsWith('organization_section')) {
                        // Handle array notation in field names (e.g., "some_name[0]" -> "organization[some_name][0]")
                        const firstBracketIndex = field_name.indexOf('[');
                        if (firstBracketIndex !== -1) {
                            const baseName = field_name.substring(0, firstBracketIndex);
                            const arrayPart = field_name.substring(firstBracketIndex);
                            return `organization[${baseName}]${arrayPart}`;
                        }
                        return `organization[${field_name}]`
                    } else {
                        return field_name;
                    }
                }
                section.element.parent('form.login_register_wrapper').find('input, select, textarea').each(function(index: number, el: any) {
                    const element = jQuery(el);
                    const type = element.attr('type');
                
                    if (type === 'checkbox') {
                        if (el.checked) {
                            data.append(build_field_name(el.name), el.value);
                        }
                    } else if (type === 'radio') {
                        if (el.checked) {
                            data.append(build_field_name(el.name), el.value);
                        }
                    } else if (type === 'file') {
                        if (el.files instanceof FileList && el.files.length > 0) {
                            for (const file of el.files) {
                                const fileFieldName = el.name.replace('_file_', '').replace(/\[\]$/, '');
                                data.append(build_field_name(fileFieldName) + '[]', file);
                            }
                        }
                    } else {
                        data.append(build_field_name(el.name), el.value);
                    }
                });
            });
            return data;
        },

        // Helper function to convert bytes to MB and format file size error messages
        formatFileSizeError: (responseText: string): string => {
            // Check if this is a file size limit error
            const fileSizeMatch = responseText.match(/POST Content-Length of (\d+) bytes exceeds the limit of (\d+) bytes/);
            
            if (fileSizeMatch) {
                const actualSize = parseInt(fileSizeMatch[1]);
                const limitSize = parseInt(fileSizeMatch[2]);
                
                // Convert bytes to MB (1 MB = 1024 * 1024 bytes)
                const actualSizeMB = (actualSize / (1024 * 1024)).toFixed(1);
                const limitSizeMB = (limitSize / (1024 * 1024)).toFixed(1);
                
                return `Total file size too large (${actualSizeMB} MB). Maximum allowed: ${limitSizeMB} MB.`;
            }
            
            // Return original message if it's not a file size error
            return responseText;
        },

        // add this helper somewhere on your object
        hasFileInputs: function(sections: Array<FormSection>) {
            const enabled = sections.filter(s => s.enabled);
            return enabled.some(section => {
            return section
                .element
                .closest('form.login_register_wrapper')
                .find('input[type="file"]').length > 0;
            });
        },

        validateFilesServerSide: async function(sections: Array<FormSection>) {
            var fileFormData = new FormData();
            const enabled_sections = sections.filter(section => section.enabled);
            
            if (enabled_sections.length <= 0) return fileFormData;
            fileFormData.append('action', 'validate_registration_files');
            fileFormData.append('nonce_validate_registration_files', register_localize.nonce_validate_registration_files);
            let file_inputs:any = {};
            enabled_sections.forEach((section, index) => {
                const build_field_name = function(field_name: string) {
                    if (section.section_id.startsWith('organization_section')) {
                        // Handle array notation in field names (e.g., "some_name[0]" -> "organization[some_name][0]")
                        const firstBracketIndex = field_name.indexOf('[');
                        if (firstBracketIndex !== -1) {
                            const baseName = field_name.substring(0, firstBracketIndex);
                            const arrayPart = field_name.substring(firstBracketIndex);
                            return `organization[${baseName}]${arrayPart}`;
                        }
                        return `organization[${field_name}]`
                    } else {
                        return field_name;
                    }
                }
                section.element.parent('form.login_register_wrapper').find('input[type="file"]').each(function(index: number, el: any) {
                    const $input_element = jQuery(el);

                    // clear old file error messages
                    $input_element.removeClass('rwmb-error');
                    $input_element.parent().find('p.rwmb-error').remove();

                    // collect files
                    if (el.files instanceof FileList && el.files.length > 0) {
                        for (const file of el.files) {
                            const fileFieldName = el.name.replace('_file_', '').replace(/\[\]$/, '');
                            const formFlieFieldName = build_field_name(fileFieldName);
                            fileFormData.append(formFlieFieldName + '[]', file);
                            if (file_inputs[formFlieFieldName]) {
                                file_inputs[formFlieFieldName].push(el);
                            } else {
                                file_inputs[formFlieFieldName] = [el];
                            }
                        }
                    }
                });
            });
    
            try {
                const response = await fetch(register_localize.admin_ajax, {
                    method: 'POST',
                    body: fileFormData,
                    credentials: 'same-origin'
                });

                if (response.headers.get('Content-Type').includes('application/json')) {
                    const data = await response.json();
                    if (!data.success) {
                        Object.entries(data.file_error_messages).forEach(([input_name, error_messages]: [string, any]) => {
                            if (error_messages.length > 0) {
                                error_messages.forEach((error_message: string, index: number) => {
                                    // Check if file_inputs[input_name] exists and has an element at the specified index
                                    if (file_inputs[input_name] && file_inputs[input_name][index]) {
                                        const input_element = file_inputs[input_name][index];
                                        if (error_message.length > 0 && input_element) {
                                            // display file error messages
                                            jQuery(input_element).addClass('rwmb-error');
                                            jQuery(input_element).parent().append(`<p class="rwmb-error">${error_message}</p>`);
                                        }
                                    } else {
                                        console.warn(`File input not found for ${input_name} at index ${index}`);
                                    }
                                });
                            }
                        });
                    }
                    return data;
                } else {
                    const userFriendlyError = this.formatFileSizeError(await response.text());
                    return {
                        success: false,
                        message: userFriendlyError,
                        file_error_messages: {}
                    };
                }
            } catch (error) {
                console.error('File validation failed:', error);
                return {
                    success: false,
                    message: 'File validation failed. Please try again.',
                    file_error_messages: {}
                };
            }
        },

        // Helper function to get file extension
        getFileExtension: function(filename: string): string {
            return filename.split('.').pop()?.toLowerCase() || '';
        },

        // Helper function to format file size
        formatFileSize: function(bytes: number): string {
            console.log('formatFileSize: ' + bytes);
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
        },

        validateFiles: async function(sections: Array<FormSection>) {
            const enabled_sections = sections.filter(section => section.enabled);
            
            if (enabled_sections.length <= 0) {
                return { success: true, message: '', file_error_messages: {} };
            }

            let totalSize = 0;
            let hasErrors = false;
            let file_error_messages: { [key: string]: string[] } = {};

            enabled_sections.forEach((section, index) => {
                const build_field_name = function(field_name: string) {
                    if (section.section_id.startsWith('organization_section')) {
                        // Handle array notation in field names (e.g., "some_name[0]" -> "organization[some_name][0]")
                        const firstBracketIndex = field_name.indexOf('[');
                        if (firstBracketIndex !== -1) {
                            const baseName = field_name.substring(0, firstBracketIndex);
                            const arrayPart = field_name.substring(firstBracketIndex);
                            return `organization[${baseName}]${arrayPart}`;
                        }
                        return `organization[${field_name}]`
                    } else {
                        return field_name;
                    }
                }

                section.element.parent('form.login_register_wrapper').find('input[type="file"]').each(function(index: number, el: any) {
                    const $input_element = jQuery(el);
                    const fieldName = build_field_name(el.name.replace('_file_', '').replace(/\[\]$/, ''));

                    // clear old file error messages
                    $input_element.removeClass('rwmb-error');
                    $input_element.parent().find('p.rwmb-error').remove();

                    // Initialize error messages array for this field
                    if (!file_error_messages[fieldName]) {
                        file_error_messages[fieldName] = [];
                    }

                    // validate files
                    if (el.files instanceof FileList && el.files.length > 0) {
                        const max_allowed_file_size = register_localize.max_allowed_file_size;
                        const allowed_mime_types = Object.keys(register_localize.allowed_mime_types);
                        for (let i = 0; i < el.files.length; i++) {
                            const file = el.files[i];
                            const fileExtension = this.getFileExtension(file.name);
                            let fileErrors: string[] = [];

                            const isAllowedType = allowed_mime_types.some((allowedType: string) => {
                                // Check if it's a MIME type or file extension
                                if (allowedType.includes('/')) {
                                    return allowedType.includes(fileExtension);
                                } else {
                                    return allowedType.toLowerCase().includes(fileExtension);
                                }
                            });
                            // Check file extension
                            if (!isAllowedType) {
                                fileErrors.push(`File "${file.name}" has an unsupported extension. Allowed: ${allowed_mime_types.join(', ').replace(/\|/g, ', ')}`);
                            }

                            // Check individual file size
                            if (file.size > max_allowed_file_size) {
                                fileErrors.push(`File "${file.name}" is too large (${this.formatFileSize(file.size)}). Maximum allowed: ${this.formatFileSize(max_allowed_file_size)}`);
                            }

                            // Add to total size
                            totalSize += file.size;

                            // Display errors for this file
                            if (fileErrors.length > 0) {
                                hasErrors = true;
                                $input_element.addClass('rwmb-error');
                                fileErrors.forEach(error => {
                                    $input_element.parent().append(`<p class="rwmb-error">${error}</p>`);
                                    file_error_messages[fieldName].push(error);
                                });
                            }
                        }
                    }
                }.bind(this)); // Bind 'this' to access fileValidationConfig
            });

            let top_error_message = '';
            // Check total size across all files
            if (!hasErrors && totalSize > register_localize.max_allowed_total_file_size) {
                hasErrors = true;
                top_error_message = `Total file size (${this.formatFileSize(totalSize)}) exceeds the limit of ${this.formatFileSize(register_localize.max_allowed_total_file_size)}`;
            }

            return {
                success: !hasErrors,
                message: top_error_message,
                file_error_messages: file_error_messages
            };
        },

        // Helper method to scroll to element if it's not visible in viewport
        scrollToElementIfNotVisible: function(element: HTMLElement, delay: number = 100) {
            setTimeout(() => {
                if (element) {
                    const rect = element.getBoundingClientRect();
                    const isVisible = (
                        rect.top >= 0 &&
                        rect.left >= 0 &&
                        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                    );
                    
                    if (!isVisible) {
                        element.scrollIntoView({ 
                            behavior: 'instant', 
                            block: 'center',
                            inline: 'center'
                        });
                    }
                }
            }, delay);
        },

        show_loader: function () {
            jQuery('.login--inline-loader-overlay').css({
                'display': 'flex',
                'align-items': 'center',
                'justify-content': 'center',
                'background-color': 'rgba(177, 177, 177, 0.1)'
            });
            jQuery('.login--inline-loader-overlay').show();
        },

        hide_loader: function () {
            jQuery('.login--inline-loader-overlay').hide();
        },

        show_error_message: function (error_message: string, section: FormSection ) {
            jQuery("#rwmb-validation-message").remove();

            // use the same error element ID with original rwmb form validation message
            var errorMessageDiv = jQuery(`
                <div id="rwmb-validation-message" class="notice notice-error is-dismissible">
                    <p>${error_message}</p>
                </div`
            );
            errorMessageDiv.insertBefore(section.element.parent('form.login_register_wrapper'));
            
            // Scroll to error message if it's not visible in viewport
            let formContainer = jQuery('#rwmb-validation-message').parent();
            if (formContainer.length > 0) {
                const particular_messages = formContainer.find('p.rwmb-error').filter(function() {
                    return this.style.display !== 'none' && this.style.visibility !== 'hidden' && this.style.opacity !== '0';
                });
                if (particular_messages.length > 0) {
                    // scroll to the first particular error message
                    this.scrollToElementIfNotVisible(particular_messages[0]);
                } else {
                    // scroll to the top error message
                    this.scrollToElementIfNotVisible(errorMessageDiv[0]);
                }
            }
        },
        
        handleSubmit: function(event: any, sections: Array<FormSection>) {
            event.preventDefault();
            // console.log('ON submit final form..')
            const self = this;
            
            // Set a timeout to allow other validation logic to run first
            setTimeout(async function() {
                // Check if this form is the last form. (Clicking on the Next button must not pass this check).
                if (jQuery(event.target).is(jQuery('form.login_register_wrapper.rwmb-form').last()) && !jQuery(event.target).attr('data-section')) {
                    // Check if there are any visible errors
                    if (jQuery('.rwmb-error').filter(function() {
                        const styleAttr = jQuery(this).attr('style');
                        return styleAttr === undefined || styleAttr === '';
                    }).length > 0) {
                        // If there are visible errors
                        console.log('Form has errors, not submitting.');
                    } else {
                        // If no errors and it's the last form
                        const formData = self.get_all_field_data(sections);

                        self.show_loader();

                        const section = sections[sections.length - 1];

                        if (self.hasFileInputs([section])) {
                            const validation = await self.validateFiles([section]);
                            // remove rwmb top validation message if exist
                            jQuery("#rwmb-validation-message").remove();
                            if (!validation.success) {
                                // show top error message
                                if (validation.message.length > 0) {
                                    self.show_error_message(validation.message, section);
                                // @ts-ignore
                                } else if (typeof rwmbValidation !== 'undefined') {
                                    // @ts-ignore
                                    self.show_error_message(rwmbValidation.message, section);
                                }
                                self.hide_loader();
                                return;
                            }
                        }

                        // Perform AJAX submission
                        jQuery.ajax({
                            type: 'POST',
                            url: register_localize.admin_ajax,
                            data: formData,
                            processData: false, 
                            contentType: false,
                            success: function(response: any) {
                                self.hide_loader();
                                if(response.success && response.alertMessage){
                                    alert(response.alertMessage);
                                }
                                if (response.success && response.redirect_url) {
                                    window.location.href = response.redirect_url;
                                }
                                else {
                                    // @ts-ignore
                                    var grecaptcha = window['grecaptcha'];
                                    if (typeof grecaptcha !== 'undefined') {
                                        grecaptcha.reset();
                                    }
                                    jQuery( '#rwmb-validation-message' ).remove(); // #77813
                                    self.show_error_message(response.error_message, sections[sections.length - 1]);
                                }
                            },
                            error: function(error: any) {
                                self.hide_loader();
                                console.error('Form submission failed:', error);
                                // Format error message for user-friendly display
                                let userFriendlyError = error;
                                if (error.responseText) {
                                    userFriendlyError = self.formatFileSizeError(error.responseText);
                                }
                                
                                // @ts-ignore
                                var grecaptcha = window['grecaptcha'];
                                if (typeof grecaptcha !== 'undefined') {
                                    grecaptcha.reset();
                                }
                                jQuery( '#rwmb-validation-message' ).remove();
                                self.show_error_message(userFriendlyError, sections[sections.length - 1]);
                            }
                        });
                    }
                }
            }, 200);
        }
    };

    get_field_data = ( section_id:string ) => {
        var field_sections:fieldArr= {};

        jQuery(`${PlatformRegister.register_form_id} [data-section="${section_id}"] [required]`).each((index:number, input_el:any) => {
            if (jQuery(input_el).closest('.rwmb-clone-template').length > 0) {
                // ignore clone template inputs which is not needed to be validated
                return;
            }
            var field_name = jQuery(input_el).attr('name');
            var field_type = jQuery(input_el).prop('tagName').toLowerCase(); // Use tag name for type
            var field_required = jQuery(input_el).attr('required') !== undefined; // Check if required attribute exists
            var field_input_type = jQuery(input_el).attr('type');
        
            var field_value:any = jQuery(input_el).val();
            if (field_input_type == "radio" || field_input_type == "checkbox") {
                field_value = jQuery(`${PlatformRegister.register_form_id} [data-section="${section_id}"] [name='${field_name}']:checked`).val();
                field_name = field_name.replace(/\[\]/g, '');
            }
        
            if (field_type == "select" && field_value === "-") {
                field_value = "";
            }
        
            // makesure value does not have whitespaces
            if (typeof(field_value) == "string") {
                field_value = field_value.trim();
            }
        
            field_sections[field_name] = {
                name: field_name,
                type: field_type,
                input_type: field_input_type,
                required: field_required,
                value: field_value
            }
        });

        return field_sections;
    }

    set_error = ( section_id:string, field_name:string, error:string='', toggle:boolean=true ) => {
        // Field names can include CSS-special chars (e.g. file inputs `_file_reg_file[]`).
        // Escape before using in an ID selector so jQuery doesn't throw Syntax error.
        const tel_input_selector = '#' + jQuery.escapeSelector(`${field_name}_tel_input`);
        var field_error = jQuery( `${PlatformRegister.register_form_id} [data-section="${section_id}"] [data-vm-field-error='${field_name}']` );
        var field = jQuery( `${PlatformRegister.register_form_id} [data-section="${section_id}"] [name='${field_name}'], ${PlatformRegister.register_form_id} [data-section="${section_id}"] ${tel_input_selector}` );

        if (field && field_error) {
            field.removeClass("rwmb-error");
            field_error.text('').hide();
            if (toggle) {
                field.addClass("rwmb-error");
                field_error.text(error).show();
            }
        }
    }

    set_required = ( section_id:string, field_sections:fieldArr={} ) => {
        if( field_sections ) {
            for( const key in field_sections ) {
                if( field_sections.hasOwnProperty(key) ) {
                    const field = field_sections[key];
                    if( field.required && (
                        ( field.value !== undefined && field.value.length === 0 ) || field.value === undefined
                    ) ) {
                        this.set_error( section_id, field.name, 'This field is required.', true );
                    } else {
                        this.set_error( section_id, field.name, '', false );

                        if( field.required ) {
                            if (field.input_type === 'email') {
                                if( !validator.isEmail( field.value ) ) {
                                    this.set_error( section_id, field.name, 'Invalid Email', true );
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    is_valid = ( field_sections:fieldArr={} ) => {
        var _valid = true;

        if( field_sections ) {
            for( const key in field_sections ) {
                if( field_sections.hasOwnProperty(key) ) {
                    const field = field_sections[key];
                    if( field.required && 
                        ((field.value != undefined && field.value.length === 0) || field.value == undefined) ) {
                        // invalid
                        _valid = false;
                    } else {
                        if( field.required ) {
                            if (field.input_type === 'email') {
                                if( !validator.isEmail( field.value ) ) {
                                    _valid = false;
                                }
                            }
                        }
                    }
                }
            }
        }

        return _valid;
    }

    match_valid = ( field_sections:fieldArr={}, field_1:string='', field_2:string='' ) => {
        if( field_sections ) {
            if( field_sections.hasOwnProperty(field_1) && field_sections.hasOwnProperty(field_2) ) {
                return ( field_sections[field_1].value == field_sections[field_2].value );
            }
        }
        return false;
    }

    get_value = (field_sections:fieldArr={}, field:string) => {
        if( field_sections ) {
            if( field_sections.hasOwnProperty(field)) {
                return field_sections[field].value;
            }
        }
        return "";
    }

    validatePhoneFieldsInSection = (section: FormSection): boolean => {
        const phoneError = register_localize.phone_invalid_error || 'Please provide a valid phone number.';
        let valid = true;

        section.element.find('.vm-address-fixed-fields input[type="tel"], .vm-address-fixed-fields input.js-phoneInput').each((_: number, telInput: any) => {
            const $tel = jQuery(telInput);
            const itiGlobals = (window as any).intlTelInputGlobals;
            const instance = itiGlobals?.getInstance ? itiGlobals.getInstance(telInput) : null;
            const rawValue = String($tel.val() || '').trim();

            if (!rawValue.length) {
                $tel.removeClass('input-wrong');
                return;
            }

            const hiddenId = ($tel.attr('id') || '').replace(/_tel_input$/, '');
            if (hiddenId && instance) {
                jQuery('#' + hiddenId).val(instance.getNumber());
            }

            const numberValid = instance ? instance.isValidNumber() : false;
            if (!numberValid || $tel.hasClass('input-wrong')) {
                valid = false;
                $tel.addClass('input-wrong');
                if (hiddenId) {
                    this.set_error(section.section_id, hiddenId, phoneError, true);
                }
            } else if (hiddenId) {
                this.set_error(section.section_id, hiddenId, '', false);
            }
        });

        return valid;
    };

    validate = async (section: FormSection) => {
        const section_id = section.section_id
        var field_sections: fieldArr = this.get_field_data(section_id);

        // if not completed :: set as required
        this.set_required(section_id, field_sections);
        var form_valid = this.is_valid( field_sections );
        if( !form_valid ) return false;

        if (!this.validatePhoneFieldsInSection(section)) {
            return false;
        }

        if (section_id === 'user_section_0') {
            const org_section = this.get_first_org_section();
            if (org_section?.enabled) {
                const org_email_field_name = org_section.element.data('organization-email-field') || undefined;
                const org_email_input = jQuery(`input[name='${org_email_field_name}']`);
                if (org_email_input.val() == this.get_value(field_sections, "str_email")) {
                    form_valid = false;
                    this.set_error( section_id, 'str_email', 'User email and organization email cannot be the same.', true );
                    this.set_error( section_id, 'str_email_conf', '', true );
                }
            }
            if( !form_valid ) return form_valid;

            // match validate email
            if( !this.match_valid( field_sections, 'str_email', 'str_email_conf' ) ) {
                this.set_error( section_id, 'str_email', '', true );
                this.set_error( section_id, 'str_email_conf', 'Email does not match', true );
                form_valid = false;
            }

            if( !this.match_valid( field_sections, 'reg_password', 'str_password_conf' ) ) {
                this.set_error( section_id, 'reg_password', '', true );
                this.set_error( section_id, 'str_password_conf', 'Password does not match', true );
                form_valid = false;
            }

            if (this.get_value(field_sections, "str_firstname").length < 2) {
                form_valid = false;
                this.set_error( section_id, 'str_firstname', 'Please enter at least 2 characters.', true );
            }

            if (this.get_value(field_sections, "str_lastname").length < 2) {
                form_valid = false;
                this.set_error( section_id, 'str_lastname', 'Please enter at least 2 characters.', true );
            }

            // email already exists check
            var emailFormData:FormData = new FormData();
            emailFormData.append( "action", "vm_email_exists" );
            emailFormData.append( "str_email", this.get_value(field_sections, "str_email") );

            const response = await fetch( register_localize.admin_ajax, {
                method: 'POST',
                credentials: 'same-origin',
                body: emailFormData,
            } );

            const data = await response.json();
            if( data && data.hasOwnProperty('success') ) {
                if( data.success && data.email_exists ) {
                    form_valid = false;
                    this.set_error( section_id, 'str_email', 'Email already exists. Please login to proceed!', true );
                    this.set_error( section_id, 'str_email_conf', '', true );
                }
                if( data.success && !data.valid_email ) {
                    form_valid = false;
                    this.set_error( section_id, 'str_email', 'Invalid field', true );
                    this.set_error( section_id, 'str_email_conf', '', true );
                }
            } else {
                // for any other condition form invalid
                form_valid = false;
            }

            return form_valid;
        }

        return form_valid;
    }
}

jQuery( document ).ready(function($:any) {
    var register = new PlatformRegister();
    if (jQuery(PlatformRegister.register_form_id).length > 0) { // check the length
        register.init();
    }
});